import __var_0__ from '@stdlib/blas/ext/base/dnannsumkbn';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var dnannsumkbn = __var_0__;


// MAIN //

/**
* Computes the sum of double-precision floating-point strided array elements, ignoring `NaN` values.
*
* @param {PositiveInteger} N - number of indexed elements
* @param {Float64Array} x - input array
* @param {integer} strideX - `x` stride length
* @param {Float64Array} out - output array
* @param {integer} strideOut - `out` stride length
* @returns {Float64Array} output array
*
* @example
* var Float64Array = require( '@stdlib/array/float64' );
*
* var x = new Float64Array( [ 1.0, -2.0, NaN, 2.0 ] );
* var out = new Float64Array( 2 );
*
* var v = dnannsum( x.length, x, 1, out, 1 );
* // returns <Float64Array>[ 1.0, 3 ]
*/
function dnannsum( N, x, strideX, out, strideOut ) {
	return dnannsumkbn( N, x, strideX, out, strideOut );
}


// EXPORTS //
export default dnannsum;
